<template>
    <div>
        <h1 class="display-heading">Received Payment Details</h1>

        <div class="mb-3">
            <table class="table table-bordered">
                <colgroup>
                    <col width="400">
                    <col>
                </colgroup>
                <tbody>
                    <tr>
                        <th>Payment ID</th>
                        <td>
                            {{payout.paymentId}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received Date</th>
                        <td>
                            {{payout.receivedDate}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Confirmed Date</th>
                        <td>
                            {{payout.confirmedDate}}
                        </td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>
                            {{payout.status}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Type</th>
                        <td>
                            {{payout.paymentType}}
                        </td>
                    </tr>
                    <tr v-if="payout.isTelehealthConsultation">
                        <th>Consultation ID</th>
                        <td>
                            {{payout.consultationId}}
                        </td>
                    </tr>
                    <tr v-else-if="payout.isPrescription">
                        <th>Prescription ID</th>
                        <td>
                            {{payout.prescriptionId}}
                        </td>
                    </tr>
                    <tr v-else-if="payout.isClinicConsultation">
                        <th>Consultation ID</th>
                        <td>
                            {{payout.consultationId}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in IPay88 (RM)</th>
                        <td>
                            {{payout.ipay88}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in Credit Balance (RM)</th>
                        <td>
                            {{payout.creditBalance}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in Company Credit (RM)</th>
                        <td>
                            {{payout.companyCredit}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in Cash (RM)</th>
                        <td>
                            {{payout.cashAmount}}
                        </td>
                    </tr>
                    <tr>
                        <th>Total Charged Amount (RM)</th>
                        <td>
                            {{payout.totalAmount}}
                        </td>
                    </tr>
                    <tr>
                        <th>{{ companyName }} Amount (RM)</th>
                        <td>
                            {{payout.hostTaking}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Amount (RM)</th>
                        <td>
                            {{payout.partnerTaking}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Disburseable Amount (RM)</th>
                        <td class="text-danger font-weight-bold">
                            {{payout.disburseableAmount}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Name</th>
                        <td>
                            {{payout.partnerName}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Bank Account Payee Name</th>
                        <td>
                            {{payout.partnerBankAccountPayeeName}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Bank Name</th>
                        <td>
                            {{payout.partnerBankName}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Bank Account Number</th>
                        <td>
                            {{payout.partnerBankAccountNumber}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div>
            <router-link :to="{'name': 'admin-received-payments'}" class="btn btn-primary btn-primary-insv">
                Back to Received Payments List
            </router-link>
        </div>

    </div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';
export default {
    'name': 'PayoutDetails',
    'computed': {
        companyName () {
            return this.$store.state.operator.companyNameDisplay;
        },
        paymentSummaryIdShort () {
            return this.$route.params.paymentId;
        }
    },
    data () {
        return {
            'payout': {
                'isDisbursed': false,
                'paymentId': '',
                'receivedDate': '',
                'confirmedDate': '',
                'status': '',
                'paymentType': '',
                'partnerName': '',
                'partnerBankAccountPayeeName': '',
                'partnerBankName': '',
                'partnerBankAccountNumber': '',
                'totalAmount': '',
                'hostTaking': '',
                'partnerTaking': ''
            },
            'paymentStatuses': [
                {
                    'text': 'All',
                    'value': -1
                },
                {
                    'text': 'Received',
                    'value': 1
                },
                {
                    'text': 'Confirmed',
                    'value': 100
                },
                {
                    'text': 'Cancelled',
                    'value': 999
                },
                {
                    'text': 'Refunded',
                    'value': 998
                },
                {
                    'text': 'Refund Fail',
                    'value': 997
                }
            ]

        };
    },
    mounted () {
        this.getPayoutDetails();
    },
    'methods': {
        getPayoutDetails () {
            this.axios.get('PaymentList/GetPaymentSummary', {
                'params': {
                    'paymentSummaryId': this.paymentSummaryIdShort
                }
            }).then(({ data }) => {
                let payoutDetails = data.data;

                if (payoutDetails) {
                    let paymentType = 'Others';

                    switch (payoutDetails.pt) {
                    case 1:
                        paymentType = 'Consultation';
                        break;
                    case 2:
                        paymentType = 'Prescription';
                        break;
                    case 3:
                        paymentType = 'Company Credit Topup';
                        break;
                    case 4:
                        paymentType = 'Clinic Consultation';
                        break;
                    case 5:
                        paymentType = 'Medicine Delivery';
                        break;
                    case 6:
                        paymentType = 'Clinic Medicine Purchase';
                        break;
                    }

                    let paymentStatus = this.paymentStatuses.find((s) => s.value === payoutDetails.ps);

                    this.payout.paymentId = payoutDetails.psids;
                    this.payout.receivedDate = payoutDetails.rd ? convertToUserReadableDateTime(payoutDetails.rd) : '-';
                    this.payout.confirmedDate = payoutDetails.cd ? convertToUserReadableDateTime(payoutDetails.cd) : '-';
                    this.payout.cancelledDate = payoutDetails.ccd ? convertToUserReadableDateTime(payoutDetails.ccd) : '-';
                    this.payout.status = paymentStatus ? paymentStatus.text : 'Unknown';
                    this.payout.paymentType = paymentType;
                    this.payout.partnerName = payoutDetails.p ? payoutDetails.p.pn : '-';
                    this.payout.partnerBankAccountPayeeName = payoutDetails.p ? payoutDetails.p.bap : '-';
                    this.payout.partnerBankName = payoutDetails.p ? payoutDetails.p.bn : '-';
                    this.payout.partnerBankAccountNumber = payoutDetails.p ? payoutDetails.p.ba : '-';
                    this.payout.totalAmount = payoutDetails.am.toFixed(2);
                    this.payout.hostTaking = payoutDetails.ha.toFixed(2);
                    this.payout.partnerTaking = payoutDetails.pa.toFixed(2);
                    this.payout.ipay88 = payoutDetails.iam.toFixed(2);
                    this.payout.creditBalance = payoutDetails.wam.toFixed(2);
                    this.payout.companyCredit = payoutDetails.cam.toFixed(2);
                    this.payout.cashAmount = payoutDetails.ca.toFixed(2);
                    this.payout.disburseableAmount = payoutDetails.da.toFixed(2);

                    this.payout.isTelehealthConsultation = payoutDetails.pt === 1;
                    this.payout.isPrescription = payoutDetails.pt === 2;
                    this.payout.isClinicConsultation = payoutDetails.pt === 4;
                    this.payout.consultationId = payoutDetails.consultationId;
                    this.payout.prescriptionId = payoutDetails.prescriptionId;
                }
            });
        }
    }
};

</script>
